export const SENTRY_APPLICATION_KEY = 'fairlo-web-app';
